var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paneles
    ? _c("div", { staticClass: "Home" }, [
        _c("div", { staticClass: "Search" }, [
          _c(
            "form",
            { staticClass: "filters" },
            [
              _c("BaseSelect", {
                attrs: {
                  value: _vm.disciplina,
                  label: _vm.$t("HOME.DISCIPLINE"),
                  tag: "disciplina",
                  options: _vm.dicName
                },
                model: {
                  value: _vm.disciplina,
                  callback: function($$v) {
                    _vm.disciplina = $$v
                  },
                  expression: "disciplina"
                }
              }),
              _c("BaseSelect", {
                attrs: {
                  value: _vm.province,
                  label: _vm.$t("HOME.PROVINCE"),
                  tag: "province",
                  options: _vm.terName
                },
                nativeOn: {
                  change: function($event) {
                    return _vm.getTerId()
                  }
                },
                model: {
                  value: _vm.province,
                  callback: function($$v) {
                    _vm.province = $$v
                  },
                  expression: "province"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "tit" }, [
          _c("h2", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.$t("HOME.LIST")) + " ")
          ])
        ]),
        _c("div", { staticClass: "result" }, [
          _c(
            "ul",
            _vm._l(_vm.filteredItems, function(panel, i) {
              return _c(
                "li",
                { key: i },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/authors/" + panel.id } },
                    [_c("AuthorCard", { attrs: { author: panel } })],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      ])
    : _c("div", [_c("BaseLoader")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }